import { render, staticRenderFns } from "./station-detail-delivery.vue?vue&type=template&id=608c70a8&scoped=true&"
import script from "./station-detail-delivery.vue?vue&type=script&lang=js&"
export * from "./station-detail-delivery.vue?vue&type=script&lang=js&"
import style0 from "./station-detail-delivery.vue?vue&type=style&index=0&id=608c70a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608c70a8",
  null
  
)

export default component.exports